import { Injectable } from '@angular/core';
// tslint:disable-next-line: no-absolute-import
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BaseUrlService {
  private apiBaseURL: string;
  private identityBaseURL: string;
  private homeBaseURL: string;

  constructor() {
    this.identityBaseURL = environment.identityUrl;
    this.apiBaseURL = environment.officeApiUrl;
  }

  public getApiBaseURL(): string {
    return this.apiBaseURL;
  }

  public getIdentityBaseURL(): string {
    return this.identityBaseURL;
  }

  public getHomeBaseURL(): string {
    return this.homeBaseURL;
  }

  public setHomeBaseUrl(val: string): void {
    this.homeBaseURL = val;
  }
}
